import {Component} from "@angular/core"
import {TranslateService} from "@ngx-translate/core"

@Component({
    selector: "tf-disclaimer-component",
    templateUrl: "./disclaimer.component.html",
    styleUrls: ["./disclaimer.component.scss"]
})
export class DisclaimerComponent {
    constructor(public readonly translate: TranslateService) {
    }
}
